export default __webpack_public_path__ + "static/media/award2016.3c16d43b.png";